import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import PopupBlockerAlert from './components/PopupBlockerAlert';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DashboardAdmin from './pages/DashboardAdmin';
import CobrancaWhatsApp from './pages/CobrancaWhatsApp';
import AgendaCobrancas from './pages/AgendaCobrancas';
import CobrancaPresencial from './pages/CobrancaPresencial';
import Lembretes from './pages/Lembretes';
import Configuracoes from './pages/Configuracoes';
import GerenciarUsuarios from './pages/GerenciarUsuarios';
import { ApiProvider } from './contexts/ApiContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import CobrancaPix from './pages/CobrancaPix';
import LinkPixAleatorio from './pages/LinkPixAleatorio';
import GerarLinkPix from './pages/GerarLinkPix';
import ResultadoLinkAleatorio from './pages/ResultadoLinkAleatorio';
import ResultadoCobrancaPix from './pages/ResultadoCobrancaPix';
import ListaPixEmitidos from './pages/ListaPixEmitidos';
import ConciliacaoPix from './pages/ConciliacaoPix';
import AnaliseCredito from './pages/AnaliseCredito';
import SimuladorViabilidadePage from './pages/SimuladorViabilidadePage';
import HistoricoAnalises from './pages/HistoricoAnalises';
import HistoricoSimulacoesViabilidade from './pages/HistoricoSimulacoesViabilidade';
import CrediarioRotativo from './pages/CrediarioRotativo';
import AlertasCrediario from './pages/AlertasCrediario';
import ConciliacaoCaixa from './pages/ConciliacaoCaixa';
import LogsErros from './pages/LogsErros';
import CorrecaoDescricao from './pages/CorrecaoDescricao';
import LogsSincronizacao from './pages/LogsSincronizacao';
import MargensLucroJuros from './pages/MargensLucroJuros';
import Margens from './pages/Margens';
import WhatsappAutomacao from './pages/WhatsappAutomacao';
import EstoqueMinimoIdeal from './pages/EstoqueMinimoIdeal';
import InventarioRotativo from './pages/InventarioRotativo';
import EstoqueCelulares from './pages/EstoqueCelulares';
import AvaliarProduto from './pages/AvaliarProduto';
import Precificacao from './pages/Precificacao';
import ArquivosEscaneados from './pages/ArquivosEscaneados';
import CaixaIdeias from './pages/CaixaIdeias';


  
// ⭐ IMPORTS PARA NOTIFICAÇÕES SSE
import useNotificacoes from './hooks/useNotificacoes';
import NotificacaoPagamento from './components/NotificacaoPagamento';
import NotificacaoUpgradeCredito from './components/NotificacaoUpgradeCredito';
import NotificacaoPrecoZerado from './components/NotificacaoPrecoZerado';
import NotificacaoVendaAbaixoPolitica from './components/NotificacaoVendaAbaixoPolitica';
import NotificacaoCustoMedioZerado from './components/NotificacaoCustoMedioZerado';
import NotificacaoNomeProdutoInvalido from './components/NotificacaoNomeProdutoInvalido';
import NotificacaoErroConexaoERP from './components/NotificacaoErroConexaoERP';
import NotificacaoAvisoPwa from './components/NotificacaoAvisoPwa';
import ConsultasPwa from './pages/ConsultasPwa';
import SessionTimeoutWarning from './components/SessionTimeoutWarning';
import './styles/notificacoes.css';
import './styles/session-timeout.css';

// Componente interno para as notificações (precisa estar dentro do AuthProvider)
function AppContent() {
  const { usuario, isAdmin, isGerenteOuAdmin } = useAuth();
  const { notificacoes, conectado, erro, removerNotificacao } = useNotificacoes();

  return (
    <div className="min-h-screen bg-gray-50">
      <SessionTimeoutWarning />
      <Routes>
        {/* Rota pública - Login */}
        <Route path="/login" element={<Login />} />
        <Route path="/pix/resultado-cobranca" element={<ResultadoCobrancaPix />} />
        <Route path="/pix/resultado-aleatorio" element={<ResultadoLinkAleatorio />} />

        {/* Rotas protegidas */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <PopupBlockerAlert />
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={isAdmin() ? <DashboardAdmin /> : <Dashboard />} />
                  <Route path="/cobranca-whatsapp" element={<CobrancaWhatsApp />} />
                  <Route path="/agenda-cobrancas" element={<AgendaCobrancas />} />
                  <Route path="/cobranca-presencial" element={<CobrancaPresencial />} />
                  <Route path="/cobranca-pix" element={<CobrancaPix />} />
                  <Route path="/link-pix-aleatorio" element={<LinkPixAleatorio />} />
                  <Route path="/pix/gerar" element={<GerarLinkPix />} />
                  <Route path="/lista-pix" element={<ListaPixEmitidos />} />
                  <Route path="/baixa-pix" element={<Navigate to="/conciliacao-pix?aba=baixa" replace />} />
                  <Route path="/conciliacao-pix" element={<ConciliacaoPix />} />
                  <Route path="/conciliacao-caixa" element={<ConciliacaoCaixa />} />
                  <Route path="/analise-credito" element={<AnaliseCredito />} />
                  <Route path="/simulador-viabilidade" element={<SimuladorViabilidadePage />} />
                  <Route path="/historico-analises" element={<HistoricoAnalises />} />
                  <Route path="/historico-simulacoes-viabilidade" element={<HistoricoSimulacoesViabilidade />} />
                  <Route path="/crediario-rotativo" element={<CrediarioRotativo />} />
                  <Route path="/crediario-alertas" element={<AlertasCrediario />} />
                  <Route path="/lembretes" element={<Lembretes />} />
                  <Route path="/logs-erros" element={<LogsErros />} />
                  <Route path="/sincronizacao/logs" element={isGerenteOuAdmin() ? <LogsSincronizacao /> : <Navigate to="/dashboard" replace />} />
                  <Route path="/margens" element={<Margens />} />
                  <Route path="/margens-lucro-juros" element={isAdmin() ? <MargensLucroJuros /> : <Navigate to="/dashboard" replace />} />
                  <Route path="/whatsapp-automacao" element={<WhatsappAutomacao />} />
                  <Route path="/estoque-min-ideal" element={<EstoqueMinimoIdeal />} />
                  <Route path="/produtos/correcao-descricao" element={<CorrecaoDescricao />} />
                  <Route path="/inventario-rotativo" element={<InventarioRotativo />} />
                  <Route path="/estoque-celulares" element={<EstoqueCelulares />} />
                  <Route path="/avaliacao-compra" element={<AvaliarProduto />} />
                  <Route path="/pedidos/precificacao" element={<Precificacao />} />
                  <Route path="/pwa/consultas" element={isGerenteOuAdmin() ? <ConsultasPwa /> : <Navigate to="/dashboard" replace />} />
                  <Route path="/arquivos-escaneados" element={<ArquivosEscaneados />} />
                  <Route path="/ideias" element={<CaixaIdeias />} />
                  <Route path="/gerenciar-usuarios" element={<GerenciarUsuarios />} />
                  <Route path="/configuracoes" element={<Configuracoes />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>

      {/* Notificações e indicadores SSE — visíveis apenas para usuários autenticados */}
      {usuario && (
        <>
          {/* Erro de conexão com o ERP — modal bloqueante, separado da pilha de toasts */}
          {notificacoes.filter(n => n.tipo === 'erro_conexao_erp').map((notificacao) => (
            <NotificacaoErroConexaoERP
              key={notificacao.id}
              notificacao={notificacao}
              onClose={() => removerNotificacao(notificacao.id)}
            />
          ))}

          <div className="fixed top-4 right-4 z-50 space-y-4">
            {notificacoes.filter(n => n.tipo !== 'erro_conexao_erp' && (n.tipo !== 'aviso_pwa' || isGerenteOuAdmin())).map((notificacao) =>
              notificacao.tipo === 'upgrade_credito' ? (
                <NotificacaoUpgradeCredito
                  key={notificacao.id}
                  notificacao={notificacao}
                  onClose={() => removerNotificacao(notificacao.id)}
                />
              ) : notificacao.tipo === 'aviso_pwa' ? (
                <NotificacaoAvisoPwa
                  key={notificacao.id}
                  notificacao={notificacao}
                  onClose={() => removerNotificacao(notificacao.id)}
                />
              ) : notificacao.tipo === 'preco_zerado' ? (
                <NotificacaoPrecoZerado
                  key={notificacao.id}
                  notificacao={notificacao}
                  onClose={() => removerNotificacao(notificacao.id)}
                />
              ) : notificacao.tipo === 'venda_abaixo_politica' ? (
                <NotificacaoVendaAbaixoPolitica
                  key={notificacao.id}
                  notificacao={notificacao}
                  onClose={() => removerNotificacao(notificacao.id)}
                />
              ) : notificacao.tipo === 'custo_medio_zerado' ? (
                <NotificacaoCustoMedioZerado
                  key={notificacao.id}
                  notificacao={notificacao}
                  onClose={() => removerNotificacao(notificacao.id)}
                />
              ) : notificacao.tipo === 'nome_produto_invalido' ? (
                <NotificacaoNomeProdutoInvalido
                  key={notificacao.id}
                  notificacao={notificacao}
                  onClose={() => removerNotificacao(notificacao.id)}
                />
              ) : (
                <NotificacaoPagamento
                  key={notificacao.id}
                  notificacao={notificacao}
                  onClose={() => removerNotificacao(notificacao.id)}
                />
              )
            )}
          </div>

          {conectado && (
            <div className="fixed bottom-4 left-4 z-40 bg-green-50 border border-green-200 rounded-lg px-3 py-2 shadow-lg">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                <span className="text-xs text-green-700 font-medium">
                  Notificações PIX ativas
                </span>
              </div>
            </div>
          )}

          {erro && (
            <div className="fixed bottom-4 left-4 z-40 bg-red-50 border border-red-200 rounded-lg px-3 py-2 shadow-lg">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-xs text-red-700">
                  Erro nas notificações
                </span>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ApiProvider>
        <AppContent />
      </ApiProvider>
    </AuthProvider>
  );
}

export default App;